import React from 'react';
import { clsx } from 'clsx';
import styles from './stepper.module.scss';
import type { SectionKey } from 'types';

type Step = {
  topLine: string;
  key: SectionKey;
};

type StepperProps = {
  steps: Step[];
  activeIndex: number;
  resultsState: Maybe<PvWizardResult>;
};

const getResultValue = (stepKey: Step['key'], resultsState: Omit<PvWizardResult, 'result'>) =>
  `${resultsState[stepKey].summary.value} ${resultsState[stepKey].summary.unit}`;

export const Stepper: React.FC<StepperProps> = ({ steps, activeIndex, resultsState }) => (
  <ol className={styles.container} aria-label="Fortschrittsanzeige" data-testid="progress-bar">
    {steps.map((step, index) => {
      const isActive = index === activeIndex;
      return (
        <React.Fragment key={step.key}>
          <li
            className={clsx({
              [styles.stepCompleted]: index < activeIndex || activeIndex === steps.length - 1,
              [styles.stepActive]: isActive,
              [styles.step]: true
            })}
            aria-current={isActive}
          >
            <span className={styles.stepNumber}>{index + 1}</span>
            <span>
              <span className={styles.stepTopLine}>
                {index < activeIndex && <span className="screen-reader-only">Abgeschlossen: </span>}
                {isActive && <span className="screen-reader-only">Aktuell: </span>}
                <span>{step.topLine}</span>
              </span>
              <span className={styles.stepResult}>
                {resultsState && getResultValue(step.key, resultsState)}
              </span>
            </span>
          </li>
          {index < steps.length - 1 && <div className={styles.stepConnector} />}
        </React.Fragment>
      );
    })}
  </ol>
);
